const $inject = ['$q', 'dataService', 'companyReferenceService', '$timeout', '$rootScope', '$scope','$http'];


const lbaCompanyReferenceCtrl = function ($q, dataService, companyReferenceService, $timeout, $rootScope, $scope,$http) {
  let vm = this;

  vm.editorActive = false;

  vm.refreshCompanyReferences = refreshCompanyReferences;
  
  vm.toggleDetail = toggleDetail;
  vm.editItem = editItem;
  
  
  
  vm.activeCompanyReference = {};
  vm.refreshCompanyReferences();
  vm.refreshGrid = null;
  vm.formLoad = undefined;
  vm.setLoadForm = (cb)=>{
    vm.formLoad = cb;
  };
  vm.gridDetails = {
    displayName: 'CompanyReferences',
    dataAt: vm.CompanyReferences,

    canCopyItem: false,
    canAddNew: true,
    gridItem: editItem,
    gridCols:
      [{name: 'DebtorIdentifier', key: 'DebtorIdentifier'},
        {name: 'ListId', key: 'ListId'},
        {name: 'NumberOfItems', key: 'NumberOfItems'}]
  };


  


  function toggleDetail(doRefresh) {
    vm.editorActive = !vm.editorActive;
    if(doRefresh){
      vm.refreshCompanyReferences();
    }
  }

  function editItem(item,loadData){ // toggle form

    vm.editorActive =true;
    vm.activeCompanyReference = item;
    vm.refreshGrid=loadData;
    if(!vm.activeCompanyReference){
      vm.activeCompanyReference = {
        DebtorIdentifier:null,
        ListId:null,
        Items:[]
      };
      vm.LoadingCompanyReference = false;
      
      vm.formLoad(vm.activeCompanyReference);
      
      
      
    }else{
      
      vm.LoadingCompanyReference = true;
      companyReferenceService.getCompanyReferenceItems(item.DebtorIdentifier,item.ListId).then((data)=>{
        vm.LoadingCompanyReference = false;
        vm.activeCompanyReference.Items = data;
        vm.formLoad(vm.activeCompanyReference);
        
        
      });
    }
    
  }

  function refreshCompanyReferences(){
    if(vm.refreshGrid){
      vm.refreshGrid();
    }else{
      $rootScope.$broadcast('companyReferenceGrid.refresh', 'doRefresh');
    }
    
  }

};

lbaCompanyReferenceCtrl.$inject = $inject;

export default lbaCompanyReferenceCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaCompanyReference/lbaCompanyReferenceCtrl.js